<template>
  <el-dialog
    :title="titleState ? $t('342') : $t('341')"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="750px"
  >
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="200px" class="demo-ruleForm">
      <el-form-item v-if="!titleState" :label="$t('347')" prop="group_name">
        <el-input maxlength="20" :placeholder="$t('90')" v-model="ruleForm.group_name" clearable> </el-input>
      </el-form-item>
      <el-form-item v-else :label="$t('347')" prop="id">
        <el-select
          clearable
          :disabled="titleState === 2"
          v-model="ruleForm.id"
          value-key="id"
          :placeholder="$t('221')"
          class="sel-auth"
          @change="groupInfo(ruleForm.id, true)"
        >
          <el-option
            v-for="item in groupOptions"
            :key="item.value"
            :label="item.group_name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item :label="$t('348')" prop="dep_id">
        <depart :change="departSelect" :mprop="{ checkStrictly: true}" :placeholder="ruleForm.dep_id"/>
        <el-popover
          v-model="popover"
          width="100%"
          ref="treePopover"
          placement="bottom"
          trigger="click"
        >
          <dep-tree v-if="popover" @node-click="handleNodeClick"></dep-tree>
        </el-popover>
        <el-input
          v-model="ruleForm.dep_name"
          v-popover:treePopover
          :placeholder="$t('19')"
          clearable
          @clear="departmentClear"
        ></el-input>
      </el-form-item> -->
      <el-form-item :label="$t('339')" prop="grant">
        <el-tree
          :data="options"
          show-checkbox
          default-expand-all
          node-key="id"
          ref="tree"
          highlight-current
          :props="defaultProps"
        ></el-tree>
      </el-form-item>
    </el-form>
    <!-- 确认取消 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="handlerDelete" class="delete-auth" type="danger" v-if="titleState">{{ $t('65') }}</el-button>
      <el-button @click="handleClose">{{ $t('66') }}</el-button>
      <el-button type="primary" plain @click="handleCreate">
        {{ $t('131') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { recouseList, createGroup, modifyGroup, remove, groupInfo } from 'api/settings'
const ruleForm = () => {
  return {
    id: '',
    group_name: '',
    grant: []
  }
}
export default {
  data() {
    return {
      groupOptions: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      popover: false,
      visible: false,
      loading: true,
      options: [],
      titleState: '',
      ruleForm: ruleForm(),
      rules: {
        id: [{ required: true, message: this.$t('820'), trigger: ['change'] }],
        group_name: [{ required: true, message: this.$t('820'), trigger: ['blur'] }]
      }
    }
  },
  methods: {
    init(val, options, data) {
      this.ruleForm = ruleForm()
      // val 1管理权限组 0新建权限组 2编辑
      this.titleState = val
      this.groupOptions = options
      this.recouseList() // 获取权限项
      const group_id = data ? data.group_id : val === 1 ? this.groupOptions[0]?.id : ''
      this.groupInfo(group_id)
      this.visible = true
    },
    // 获取权限资源列表
    recouseList() {
      recouseList().then(res => {
        this.options = res.data
      })
    },
    async groupInfo(group_id, status) {
      if (group_id) {
        const { data } = await groupInfo({ group_id })
        this.ruleForm = data
      } else {
        this.ruleForm.grant = []
      }
      this.$nextTick(() => {
        if (!status) this.$refs.ruleForm.clearValidate()
        if (this.$refs.tree) this.$refs.tree.setCheckedKeys(this.ruleForm.grant)
      })
    },
    // 部门选择
    departSelect(params, current, c) {
      this.ruleForm.dep_id = current.slice(-1)[0]
    },
    handleClose() {
      this.$refs.ruleForm.clearValidate()
      this.ruleForm = ruleForm()
      this.visible = false
    },
    // 创建或修改
    handleCreate() {
      const arr = this.$refs.tree.getCheckedKeys()
      this.ruleForm.grant = arr
      // 权限数组
      let api = createGroup
      if (this.titleState) {
        api = modifyGroup
        this.ruleForm.group_id = this.ruleForm.id
        this.ruleForm.department_id = this.ruleForm.dep_id
      }
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          api(this.ruleForm).then(() => {
            this.$message.success(this.$t('821'))
            this.$parent.handleGroupList()
            this.handleClose()
          })
        }
      })
    },
    // 删除权限组
    handlerDelete() {
      if (this.ruleForm && this.ruleForm.id) {
        remove({ group_id: this.ruleForm.id }).then(() => {
          this.visible = false
          this.ruleForm = {}
          this.$parent.handleGroupList()
          this.$parent.handlerGroupStaffList(1)
        })
      }
    },
    handleNodeClick(val) {
      this.ruleForm.dep_id = val.department_id
      this.ruleForm.dep_name = val.department_name
      this.popover = false
    },
    departmentClear() {
      this.ruleForm.dep_id = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.delete-auth {
  float: left;
}
/deep/ .el-input {
  width: 360px;
  max-width: 320px;
  height: 32px;
  input {
    height: 32px;
  }
}
/deep/ .el-dialog__body {
  min-height: 200px;
}
</style>
>
